import axios from 'axios';


// export const updateCoupon = async (id,status) => {
//   try {
//     const res = await axios.post('/',{bannerId: id,status:status});
//     return res.data;
//   } catch (e) {
//     console.error(e);
//     return e.response.data;
//   }
// };
export const deleteCoupon = async (deleteid) => {
      try {
        const res = await axios.post('/delete-coupon',{id: deleteid});
        return res.data;
      } catch (e) {
        console.error(e);
        return e.response.data;
      }
};
export const addCoupon = async (type, formData) => {
      const url = type === "EDIT" ? "/" : "/add-coupon"
      try {
          const res = await axios.post(url,formData);
          return res.data;
      } catch (e) {
        console.error(e);
        return e.response.data;
      }
};
export const getActiveCategory = async () => {
      try {
          const res = await axios.get('/getAllActiveCategory');
          return res.data;
      } catch (e) {
        return e.response.data;
      }
};
export const getActiveProducts = async () => {
  try {
      const res = await axios.post('/getAllActiveProducts',{userId: '112'});
      return res.data;
  } catch (e) {
    return e.response.data;
  }
};
export const getAllPartners = async () => {
  try {
      const res = await axios.post('/getAllPartner',{userId: '112'});
      return res.data;
  } catch (e) {
    return e.response.data;
  }
};
export const getCouponDetails = async (couponData) => {
  const url = "/coupon-details";
  try {
      const res = await axios.post(url,couponData);
      return res.data;
  } catch (e) {
    console.error(e);
    return e.response.data;
  }
};